/* eslint no-unused-vars: 0 */
import $ from "jquery";

// import initScrollTo from "./scroll-to";
import mobileMenu from "./mobile-menu";
import sideMenu from "./sidemenu";
import accordionItemToggle from "./accordionItemToggle";
import autoScroll from "./autoscroll";
import loginClick from "./login-click";

import "./reveal-dropdown";
import "./header-scroll";
import "./scroll-to-top";


$(document).ready(() => {

    // const $jsScrollTo = $(".js-scroll-to");
    // if ($jsScrollTo.length) {
    //     $jsScrollTo.map((i, v) => initScrollTo(v));
    // }

    const $jsMobileMenu = $(".js-toggle-menu");
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsSideMenu = $(".js-toggle-sidemenu");
    if ($jsSideMenu.length) {
        $jsSideMenu.map((i, v) => sideMenu(v));
    }

    const $jsAccordion = $(".js-accordion");
    if ($jsAccordion.length) {
        $jsAccordion.map((i, v) => accordionItemToggle(v));
    }
    const $jsAutoScroll = $(".auto-scroll-column");
    if ($jsAutoScroll.length) {
        $jsAutoScroll.map((i, v) => autoScroll(v));
    }

    const $jsLoginClick = $(".js-login-form");
    if ($jsLoginClick .length) {
        $jsLoginClick .map((i, v) => loginClick(v));
    }

});
